var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _rect, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 61,
    viewBox: "0 0 33 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8457 42.2274C3.8457 41.1019 4.29278 40.0226 5.08859 39.2268C5.8844 38.431 6.96375 37.9839 8.08919 37.9839H25.0632C26.1886 37.9839 27.2679 38.431 28.0638 39.2268C28.8596 40.0226 29.3066 41.1019 29.3066 42.2274V45.0564C29.3066 46.1818 28.8596 47.2612 28.0638 48.057C27.2679 48.8528 26.1886 49.2999 25.0632 49.2999H8.08919C6.96375 49.2999 5.8844 48.8528 5.08859 48.057C4.29278 47.2612 3.8457 46.1818 3.8457 45.0564V42.2274Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50293 43.6416V43.655Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50293 43.6416V43.655",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1616 43.6416H23.6486Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1616 43.6416H23.6486",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8457 30.9115C3.8457 29.786 4.29278 28.7067 5.08859 27.9109C5.8844 27.115 6.96375 26.668 8.08919 26.668H25.0632C26.1886 26.668 27.2679 27.115 28.0638 27.9109C28.8596 28.7067 29.3066 29.786 29.3066 30.9115V33.7405C29.3066 34.8659 28.8596 35.9452 28.0638 36.7411C27.2679 37.5369 26.1886 37.9839 25.0632 37.9839H8.08919C6.96375 37.9839 5.8844 37.5369 5.08859 36.7411C4.29278 35.9452 3.8457 34.8659 3.8457 33.7405V30.9115Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50342 32.3257V32.3391Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50342 32.3257V32.3391",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1616 32.3257H23.6486Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1616 32.3257H23.6486",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8457 19.5951C3.8457 18.4696 4.29278 17.3903 5.08859 16.5945C5.8844 15.7986 6.96375 15.3516 8.08919 15.3516H25.0632C26.1886 15.3516 27.2679 15.7986 28.0638 16.5945C28.8596 17.3903 29.3066 18.4696 29.3066 19.5951V22.424C29.3066 23.5495 28.8596 24.6288 28.0638 25.4246C27.2679 26.2205 26.1886 26.6675 25.0632 26.6675H8.08919C6.96375 26.6675 5.8844 26.2205 5.08859 25.4246C4.29278 24.6288 3.8457 23.5495 3.8457 22.424V19.5951Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50342 21.0098V21.0232Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50342 21.0098V21.0232",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1616 21.0098H23.6486Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1616 21.0098H23.6486",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8457 8.27962C3.8457 7.15418 4.29278 6.07483 5.08859 5.27902C5.8844 4.48321 6.96375 4.03613 8.08919 4.03613H25.0632C26.1886 4.03613 27.2679 4.48321 28.0638 5.27902C28.8596 6.07483 29.3066 7.15418 29.3066 8.27962V11.1086C29.3066 12.2341 28.8596 13.3134 28.0638 14.1092C27.2679 14.905 26.1886 15.3521 25.0632 15.3521H8.08919C6.96375 15.3521 5.8844 14.905 5.08859 14.1092C4.29278 13.3134 3.8457 12.2341 3.8457 11.1086V8.27962Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50342 9.69385V9.70729Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50342 9.69385V9.70729",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1616 9.69385H23.6486Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1616 9.69385H23.6486",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.825137,
    y: 0.642031,
    width: 31.502,
    height: 52.0531,
    rx: 6.99802,
    stroke: "black",
    strokeWidth: 1.12
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50395 52.9709V53.7861C8.50395 57.0977 5.81939 59.7823 2.50781 59.7823V59.7823",
    stroke: "black",
    strokeWidth: 1.12
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6308 52.7979V53.7865C24.6308 57.0981 27.3154 59.7827 30.627 59.7827V59.7827",
    stroke: "black",
    strokeWidth: 1.12
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50391 55.7393L24.6307 55.7393",
    stroke: "black",
    strokeWidth: 1.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRack1);
export default __webpack_public_path__ + "static/media/rack1.471fbdbccfd962dcaaffe202449ce786.svg";
export { ForwardRef as ReactComponent };